define([
	"libs/polyglot"
], function (Polyglot) {

	function getUsers() {
		return typeof window !== "undefined" ? window.__userModule : null;
	}

	var defaultlang = "ru-RU";
	var key = "--:app:lang";
	var current_lang = webix.storage.local.get(key) || defaultlang;

	var _change_locale_server = function () {
		var request = {};
		request.locale = _unmap_lang(_get_lang());
		webix.ajax().headers({
			"Content-type": "application/json"
		}).post(API_URL + "api/personal/v1.0/locale?locale=" + request.locale, {}, {
			success: function (text, data, XmlHttpRequest) {
				webix.message({
					type: "success",
					text: "✓"
				});
				document.location.reload();
			},
			error: function (text, data, XmlHttpRequest) {
				var response;
				try {
					response = JSON.parse(text);
					if (response.errMsg)
						webix.message({
							type: "error",
							text: response.errMsg ? response.errMsg : "x"
						});

				} catch (e) {
					webix.message({
						type: "error",
						text: "x"
					});
				}
			}
		});

	};

	function _get_lang(){
		var backLang = webix.storage.local.get(key);

		if(backLang)
			return webix.storage.local.get(key);
		else
			return defaultlang;

		// if(users.getCurrentUser())
		// 	return users.getCurrentUser().settings.language;
		// ;
	}

	function _set_lang(lang, skipServerSync) {
		current_lang = lang;
		webix.storage.local.put(key, lang);
		var users = getUsers();
		if (users && users.getCurrentUser()) {
			users.saveSetting("language", lang, lang != current_lang);
		}
		if (!skipServerSync) {
			_change_locale_server();
		}
	}

	function _map_lang(input) {
		// Define the map
		var valueMap = {
			'en': 'en-US',
			'arm': 'hy-AM',
			'ru': 'ru-RU',
			'hy': 'hy-AM'
		};

		return valueMap[input];
	}

	function _unmap_lang(input) {
		return input.split("-")[0];
	}

	function create_locale(lang){
		current_lang = lang;
		define("locale", [
			"locales/"+lang
		], function(data){
			var poly = new Polyglot({ phrases:data });
				poly.locale(lang);

			var t = webix.bind(poly.t, poly);
			t.template = function(a){
				return a.replace(/%([a-zA-Z0-9.]+)%/g, function(_, match){
					return poly.t(match);
				});
			};
			return t;
		});
	}

	var api = {
		$oninit: function (app, config) {
			webix.i18n.setLocale('ru-RU');
		},
		mapLanguage: _map_lang,
		setLang: _set_lang,
		getLang: _get_lang,
		changeLang: _change_locale_server,
		isNow: function (val) { return val == current_lang; }
	};

	if (typeof window !== "undefined")
		window.__localeModule = api;

	return api;
});